import lockOpen from '@iconify/icons-heroicons-outline/lock-open';
import { Icon } from '@iconify/react';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { useAuth } from 'react-oidc-context';

import CenterCard from './CenterCard';

export default function AuthGate() {
  const auth = useAuth();
  const { t } = useTranslation();

  if (auth.isLoading) {
    return (
      <CenterCard title="Authentication Required">
        <p className="m-0 text-gray-700">{t('auth.initializing')}</p>
      </CenterCard>
    );
  }

  return (
    <CenterCard title={t('auth.requiredTitle')}>
      <p className="mt-3 text-gray-700">{t('auth.requiredBody')}</p>
      <button
        onClick={() => auth.signinRedirect()}
        className="mt-5 inline-flex w-full items-center justify-center gap-2 rounded-lg bg-blue-600 px-4 py-3 font-semibold text-white hover:bg-blue-700 focus:outline-none focus:ring-4 focus:ring-blue-200"
        aria-label={t('auth.start')}
      >
        <Icon icon={lockOpen} className="h-5 w-5" aria-hidden="true" />
        <span>{t('auth.start')}</span>
      </button>
    </CenterCard>
  );
}
